import moment from 'moment';

export default class TalkService {
    static $inject = ['MessagingHubService'];
    constructor(MessagingHubService) {
        'ngInject';

        this._messagingHubService = MessagingHubService;
    }

    async registerClassifier(classifier, json) {
        return this._messagingHubService.sendCommand({
            method: 'set',
            type: 'application/json',
            to: 'postmaster@talkservice.msging.net',
            uri: '/classifiers/' + classifier,
            resource: json,
        });
    }

    //Intentions
    async registerIntention(faq) {
        return this._messagingHubService.sendCommand({
            method: 'set',
            type: 'application/json',
            to: 'postmaster@talkservice.msging.net',
            uri: '/intention',
            resource: faq,
        });
    }

    async getIntentions() {
        return this._messagingHubService.sendCommand({
            method: 'get',
            to: 'postmaster@talkservice.msging.net',
            uri: '/intention',
        });
    }

    async getIntention(id) {
        return this._messagingHubService.sendCommand({
            method: 'get',
            to: 'postmaster@talkservice.msging.net',
            uri: `/intention/${id}`,
        });
    }

    async deleteIntention(id) {
        return this._messagingHubService.sendCommand({
            method: 'delete',
            to: 'postmaster@talkservice.msging.net',
            uri: `/intention/${id}`,
        });
    }

    async getContext() {
        return this._messagingHubService.sendCommand({
            method: 'get',
            to: 'postmaster@talkservice.msging.net',
            uri: '/contexts',
        });
    }

    async setContext() {
        return this._messagingHubService.sendCommand({
            method: 'set',
            to: 'postmaster@talkservice.msging.net',
            uri: '/contexts',
            type: 'application/json',
            resource: {},
        });
    }

    //Questions
    async getQuestions(id) {
        return this._messagingHubService.sendCommand({
            method: 'get',
            to: 'postmaster@talkservice.msging.net',
            uri: `/training?idRule=${id}`,
        });
    }

    async getUnknownQuestions() {
        const formatedDate = moment()
            .add(-7, 'days')
            .format('YYYY-MM-DD');

        return this._messagingHubService.sendCommand({
            method: 'get',
            to: 'postmaster@talkservice.msging.net',
            uri: `/request?startDate=${formatedDate}&minConfidence=0&maxConfidence=1&uncertain=true`,
        });
    }

    async setRequestFeedback(resource) {
        return this._messagingHubService.sendCommand({
            method: 'set',
            type: 'application/json',
            to: 'postmaster@talkservice.msging.net',
            uri: '/request',
            resource: resource,
        });
    }

    async addQuestion(resource) {
        return this._messagingHubService.sendCommand({
            method: 'set',
            type: 'application/json',
            to: 'postmaster@talkservice.msging.net',
            uri: '/training',
            resource: resource,
        });
    }

    async deleteUnknownQuestion(resource) {
        return this._messagingHubService.sendCommand({
            method: 'set',
            type: 'application/json',
            to: 'postmaster@talkservice.msging.net',
            uri: '/request',
            resource: resource,
        });
    }

    async trainSet() {
        return this._messagingHubService.sendCommand({
            method: 'set',
            type: 'application/vnd.lime.identity',
            to: 'postmaster@talkservice.msging.net',
            uri: '/contexts/training',
            resource: {},
        });
    }

    async publishSet() {
        return this._messagingHubService.sendCommand({
            method: 'set',
            type: 'application/vnd.lime.identity',
            to: 'postmaster@talkservice.msging.net',
            uri: '/contexts/publish',
            resource: {},
        });
    }
}
